module.exports = __webpack_public_path__ + "static/media/logo-positive-vertical.2902cb5b.jpg";